import * as React from "react";
import {Redirect} from "react-router";
import BaseComponent from "components/BaseComponent";
import RadioButton from "components/form/RadioButton/RadioButton";
import RadioButtonGroup from "components/form/RadioButton/RadioButtonGroup";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {Errors} from "components/DataBaseComponent/DataBaseComponent";
import {
  ExpandableFormSection,
  Summary,
  FormSectionHeading,
  Text,
  required,
  Note,
  Select,
  SummaryNode
} from "components/form";
import CodeEditor, {TextFormat} from "components/CodeEditor/CodeEditor";
import {
  AzureTemplateHelper,
  ParameterValue,
  ParameterValues,
  ParameterDataType,
  Source
} from "./AzureTemplateHelper";

interface AzureResourceGroupSourceCodeDialogProps {
  template: string;
  saveDone(newTemplate: string): any;
}

interface AzureResourceGroupSourceCodeDialogState {
  template: string;
  errors?: Errors;
}

class AzureResourceGroupSourceCodeDialog extends BaseComponent<AzureResourceGroupSourceCodeDialogProps, AzureResourceGroupSourceCodeDialogState> {
    constructor(props: any) {
        super(props);
        this.state = {
          errors: null,
          template: this.props.template
        };
    }

    async save() {
      const result = AzureTemplateHelper.extractParameters(this.state.template);
      if (result.errors.length > 0) {
        this.setState({
          errors: {
            message: "The source code contains errors",
            details: [...result.errors],
            fieldErrors: {}
        }});
      } else {
        await this.props.saveDone(this.state.template);
        return true;
      }
    }

    render() {
        return <SaveDialogLayout title={"Template source code"}
                                 busy={null}
                                 errors={this.state.errors}
                                 onSaveClick={() => this.save()}>
        <CodeEditor value={this.state.template}
            language={TextFormat.JSON}
            allowFullScreen={false}
            onChange={(template) => this.setState({template})}
        />
        </SaveDialogLayout>;
    }
}

export default AzureResourceGroupSourceCodeDialog;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/azureResourceGroup/AzureResourceGroupSourceCodeDialog.tsx